module.exports = __webpack_public_path__ + "img/ICONO11.34fbee08.png";